/**
 * User Service
 * API calls for user management
 */

import api from './api';

export const userService = {
  // Get all users with filters
  getUsers: (params = {}) => api.get('/users', params),

  // Get single user
  getUser: (id) => api.get(`/users/${id}`),

  // Create user
  createUser: (userData) => api.post('/users', userData),

  // Update user
  updateUser: (id, userData) => api.put(`/users/${id}`, userData),

  // Delete user
  deleteUser: (id) => api.delete(`/users/${id}`),

  // Reset user password
  resetPassword: (id, password) => api.put(`/users/${id}/resetpassword`, { password }),

  // Bulk update status
  bulkUpdateStatus: (userIds, status) => api.put('/users/bulk/status', { userIds, status }),

  // Check if email exists
  checkEmail: (email, excludeId) => api.post('/users/check-email', { email, excludeId }),
};

export default userService;
